<script setup lang="ts">
import { useDisplay } from 'vuetify';

const { xs: isPhone, mdAndDown } = useDisplay();

type Emits = {
  (e: 'close'): void;
};
const emit = defineEmits<Emits>();

type Props = {
  modelValue: boolean; // state of dialog window
  fullHeight?: boolean;
};
withDefaults(defineProps<Props>(), {
  fullHeight: false,
});
</script>

<template>
  <v-dialog
    :model-value="modelValue"
    :height="'100%'"
    :width="'100vh'"
    :max-width="'100%'"
    :close-on-content-click="false"
    :persistent="false"
    :fullscreen="isPhone"
    transition="dialog-bottom-transition"
    class="dialog ma-0"
    :class="{
      'mt-16': isPhone,
    }"
    @click:outside="emit('close')"
    @keydown.esc="emit('close')"
    @close="emit('close')"
  >
    <v-card
      class="py-4 drawer-content bg-surface-container"
      :class="[mdAndDown ? 'rounded-t-xl px-4' : 'px-8', fullHeight ? 'h-100vh' : 'h-auto']"
    >
      <slot name="default"></slot>
    </v-card>
  </v-dialog>
</template>

<style scoped lang="scss">
.h-100vh {
  height: 100vh !important;
}
:deep(.v-overlay__content) {
  top: auto !important;
  bottom: 0;
  height: auto !important; // added
  margin-bottom: 0 !important;
}
.drawer-content {
  overflow: hidden !important;
}

.v-card {
  padding-bottom: max(env(safe-area-inset-bottom, 0px), 16px) !important;
}
</style>
